import { defineStore } from "pinia";

export type LoaderType = "global" | "button";

export const useLoader = defineStore("loader", {
  state: () => ({
    counters: {
      global: 0,
      button: 0,
    } as Record<LoaderType, number>,
  }),

  getters: {
    loading:
      state =>
        (type: LoaderType = "global"): boolean =>
          state.counters[type] !== 0,
  },

  actions: {
    increment(type: LoaderType = "global"): void {
      this.counters[type]++;
    },

    decrement(type: LoaderType = "global"): void {
      if (this.counters[type] === 0) return;

      this.counters[type]--;
    },
  },
});
